module.exports = __webpack_public_path__ + "static/media/copyright.fdc40198.svg";